import styled from 'styled-components';
import { Props } from './types';

const Container = styled.div<Props>`
  width: ${({ width, isMobile, landscape }: any) =>
    isMobile ? (!landscape ? '95vw' : '70vw') : `${width || 350}px`};
  height: ${({ height, isMobile }: any) => (isMobile ? 'auto' : `${height || 200}px`)};
  position: absolute;
  bottom: 70px;
  left: ${({ isMobile, landscape }) => (isMobile && !landscape ? '10px' : '60px')};
  z-index: 100;
`;

const Iframe = styled.iframe`
  height: 100%;
  width: 100%;
  position: relative;
  top: 0;
  left: 0;
  transition: all 0.25s ease;
`;

const Icon = styled.i`
  position: absolute;
  right: -10px;
  top: -10px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  color: #fff;
  padding: 8px;
  font-size: 14px;
  line-height: 10px;
  z-index: 2;
  cursor: pointer;
`;

export default { Container, Iframe, Icon };
